// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8IFs1","leftCol":"styles_leftCol__TxwKZ","rightCol":"styles_rightCol__QhY9y","tooltip":"styles_tooltip__jMxw-"};